import React from "react";
import { Card, Link, Table, TableBody, TableCell, TableRow, Text } from "@jsq/ds/core";
import { formatCalendarDate } from "#utils/datetime_utils";
import Money from "../../../../Money";
import { MoneyType } from "../../../../Money/types";
import { tableCell, tableRow } from "./styles_vanilla.css";

export type TransactionDetailsCardProps = {
  clientName: string;
  investmentEntityName: string;
  label: string;
  subtitleLabel?: string | null;
  description?: string | null;
  transactionUrl?: string | null;
  effectiveDate: string;
  requestedPaymentDate?: string | null;
  totalAmountPayable: MoneyType;
  amountMarkedPaid: MoneyType;
  amountPaidViaAutomatedPayments: MoneyType;
  amountInCurrentBatch: MoneyType;
};

export const TransactionDetailsCard: React.FC<TransactionDetailsCardProps> = (props) => {
  const transactionType = props.subtitleLabel
    ? `${props.label} (${props.subtitleLabel})`
    : props.label;

  const remainingToPay: MoneyType = {
    amount:
      props.totalAmountPayable.amount -
      props.amountMarkedPaid.amount -
      props.amountPaidViaAutomatedPayments.amount -
      props.amountInCurrentBatch.amount,

    currency: props.totalAmountPayable.currency,
    precision: props.totalAmountPayable.precision,
  };

  return (
    <Card title="Transaction details">
      <Table condensed>
        <TableBody>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text>Client</Text>
            </TableCell>
            <TableCell>
              <Text>{props.clientName}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text>Investment entity</Text>
            </TableCell>
            <TableCell>
              <Text>{props.investmentEntityName}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text>Transaction type</Text>
            </TableCell>
            <TableCell>
              <Text>{transactionType}</Text>
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text>Transaction description</Text>
            </TableCell>
            <TableCell>
              {props.transactionUrl && props.description ? (
                <Link
                  href={props.transactionUrl}
                  align="left"
                  icon="external-link"
                  iconPosition="right"
                  shouldOpenInNewTab
                >
                  {props.description}
                </Link>
              ) : (
                <Text>{props.description ?? "—"}</Text>
              )}
            </TableCell>
          </TableRow>
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text>Transaction date</Text>
            </TableCell>
            <TableCell>
              <Text>{formatCalendarDate(props.effectiveDate) ?? ""}</Text>
            </TableCell>
          </TableRow>
          {props.requestedPaymentDate && (
            <TableRow className={tableRow}>
              <TableCell className={tableCell}>
                <Text>Requested payment date</Text>
              </TableCell>
              <TableCell>
                <Text>{formatCalendarDate(props.requestedPaymentDate) ?? ""}</Text>
              </TableCell>
            </TableRow>
          )}
          <TableRow className={tableRow}>
            <TableCell className={tableCell}>
              <Text>Remaining to pay</Text>
            </TableCell>
            <TableCell>
              <Money money={remainingToPay} rounded={false} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Card>
  );
};
